import styled from 'styled-components';
export const Container = styled.div.withConfig({
  displayName: "Associationsstyle__Container",
  componentId: "x6b1t-0"
})(["position:relative;"]);